import { html } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import { encodeHtmlEntities } from '@mfe/util/helpers';
import { ConsentType } from '@mfe/types/common';
import featureDef from '@mfe/defs/features';
import { doToggle } from '../util';

export const featuresTemplate = (consent: ConsentType, disabled: boolean, id: string) => {
  const existedFeatures = featureDef.filter((feature) => consent[feature]);
  return html`
    <div class="form-row">
      ${existedFeatures /* eslint-disable indent, @typescript-eslint/indent */
        .map((feature) => consent[feature].map(({
           id: fid, granted, title, description,
          }) => {
          const featureLabel = (
            description === title
              ? title
              : `<div>
                <abbr title="${encodeHtmlEntities(description)}">
                  ${title}
                </abbr>
              </div>`);

          const checkboxId = `${id}_${feature}_${fid}`;

          if (disabled) {
            return html`
              <div>
                  <tef-coms-icon .icon="${granted ? 'check' : 'cross'}" size="l"></tef-coms-icon>
                  <span>
                      ${unsafeHTML(featureLabel)}
                  </span>
              </div>`;
          }

          return html`
            <div class="form-group-checkbox form-group-checkbox--size-small">
              <input
                id=${checkboxId}
                name=${checkboxId}
                type="checkbox"
                .checked=${granted}
                @click=${doToggle({
                  id,
                  fid,
                  feature,
                })}
              >
              <label for=${checkboxId}>
                ${unsafeHTML(featureLabel)}
              </label>
            </div>
          `;
        }))
      /* eslint-enable indent, @typescript-eslint/indent */}
    </div>
    `;
};

export default featuresTemplate;
